import React, { useState, useRef, useEffect } from 'react';
import Transition from '../utils/Transition.js';
import axios from 'axios';
import { message } from 'antd';

function DropdownFilter(
  props
) {
  const [products,setProducts]=useState([])
  useEffect(() => {
    axios
      .get(`https://adminapi.youjifresh.com/products?_sort=created_at:DESC`, {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("youji_token"),
          "Content-Type": "application/json"
        }
      })
      .then(function (response) {
        console.log(response.data);
        setProducts(response.data);
  
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const trigger = useRef(null);
  const dropdown = useRef(null);

  const [name,setName]=useState('')
  const [price,setPrice]=useState()

 


  // close on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!dropdown.current) return;
      if (!dropdownOpen || dropdown.current.contains(target) || trigger.current.contains(target)) return;
      setDropdownOpen(false);
    };
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  });

  
  const apply = () => {
    setDropdownOpen(false)
    if(name){
      setPrice('')
      products.filter(p=>p.Name===name)
      props.sendData( products.filter(p=>p.Name===name))
    }
    else if(price){
      setName('')
      products.filter(p=>p.price.toString()===price)
      props.sendData(products.filter(p=>p.price.toString()===price))
    }
    else{
      message.warning('Enter some value')
      
    }
  }
  const clear = () => {
    setDropdownOpen(false)
    console.log(products)
    props.clearData(products)
    setName('')
    setPrice('')
  }

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!dropdownOpen || keyCode !== 27) return;
      setDropdownOpen(false);
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  });
  


  return (
    <div className="relative inline-flex">
      <button
        ref={trigger}
        className="btn bg-white border-gray-200 hover:border-gray-300 text-gray-500 hover:text-gray-600"
        aria-haspopup="true"
        onClick={() => setDropdownOpen(!dropdownOpen)}
        aria-expanded={dropdownOpen}
      >
        <span className="sr-only">Filter</span><wbr />
        <svg className="w-4 h-4 fill-current" viewBox="0 0 16 16">
          <path d="M9 15H7a1 1 0 010-2h2a1 1 0 010 2zM11 11H5a1 1 0 010-2h6a1 1 0 010 2zM13 7H3a1 1 0 010-2h10a1 1 0 010 2zM15 3H1a1 1 0 010-2h14a1 1 0 010 2z" />
        </svg>
      </button>
      <Transition
        show={dropdownOpen}
        tag="div"
        className={`origin-top-right z-10 absolute top-full min-w-56 bg-white border border-gray-200 pt-1.5 rounded shadow-lg overflow-hidden mt-1 ${props.align === 'right' ? 'right-0' : 'left-0'}`}
        enter="transition ease-out duration-200 transform"
        enterStart="opacity-0 -translate-y-2"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-out duration-200"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
      >
        <div ref={dropdown}>
          <div className="text-xs font-semibold text-gray-400 uppercase pt-1.5 pb-2 px-4">Filters</div>
          <ul className="mb-4">
            <li className="py-1 px-3">
              <label className="flex items-center">
                
                <span className="text-sm font-medium ml-2">Name</span> <span className="text-sm font-medium ml-2">=</span>
                <input type="text" className="text-sm font-medium ml-2 h-8" value={name} onChange={e=>{setPrice('');setName(e.target.value)}}></input>
              </label>
            </li>
            <li className="py-1 px-3">
              <label className="flex items-center">
               
              <span className="text-sm font-medium ml-3">Price </span> <span className="text-sm font-medium ml-2">=</span>
                <input type="number" className="text-sm font-medium ml-2 h-8" value={price} onChange={e=>{setName('');setPrice(e.target.value);console.log(e.target.value)}}></input>
              </label>
            </li>
    

          </ul>
          <div className="py-2 px-3 border-t border-gray-200 bg-gray-50">
            <ul className="flex items-center justify-between">
              <li>
                <button className="btn-xs bg-white border-gray-200 hover:border-gray-300 text-gray-500 hover:text-gray-600" onClick={clear}>Clear</button>
              </li>
              <li>
                <button className="btn-xs bg-indigo-500 hover:bg-indigo-600 text-white" onClick={apply} onBlur={() => setDropdownOpen(false)}>Apply</button>
              </li>
            </ul>
          </div>

        

          

        </div>
      </Transition>
    </div>
  );
}

export default DropdownFilter;
